export default __webpack_public_path__ + "static/media/mobileBannerImg.c426c7a5.svg";